import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./user";
import artworkReducer from "./artwork";

const reducer = combineReducers({
  user: userReducer,
  artwork: artworkReducer,
});

const store = configureStore({ reducer });

export type RootState = ReturnType<typeof store.getState>;

export default store;
